import {createApp} from 'vue'
import StafetMailudsendelseList from './StafetMailudsendelseList'

const el = '.kb-component--stafet-mailudsendelse-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetMailudsendelseListDOM)=>{
            const mailudsendelser = JSON.parse(decodeHtml(StafetMailudsendelseListDOM.dataset.mailudsendelser))
            const component = createApp(StafetMailudsendelseList, { mailudsendelser }).use(Store)
            component.mount(StafetMailudsendelseListDOM)
        })
    }
}

const decodeHtml = (htmlRaw) => {
    const txt = document.createElement('textarea')
    txt.innerHTML = htmlRaw
    return txt.value
}